import React, { useEffect, useState, useContext } from "react";
import "./externalOrders.css";
import ReactPaginate from "react-paginate";
import axios from "axios";
import { UserContext } from "../../contexts/user.context";
import { LoadingContext } from "../../contexts/loading.context";
import { OrderViewModal } from "../../components";

import { ModalBody, ModalContainer } from "../../components/modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

import { useMediaQuery } from "react-responsive";

const prevIcon = (
    <svg
        style={{ cursor: "pointer" }}
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.5 13.3727C8.83333 12.9848 8.83333 12.0152 9.5 11.6273L15.5 8.13651C16.1667 7.74865 17 8.23348 17 9.00921V15.9908C17 16.7665 16.1667 17.2514 15.5 16.8635L9.5 13.3727Z"
            fill="#37474F"
        />
        <path
            d="M2 1H24V-1H2V1ZM25 2V23H27V2H25ZM24 24H2V26H24V24ZM1 23V2H-1V23H1ZM2 24C1.44772 24 1 23.5523 1 23H-1C-1 24.6569 0.343146 26 2 26V24ZM25 23C25 23.5523 24.5523 24 24 24V26C25.6569 26 27 24.6569 27 23H25ZM24 1C24.5523 1 25 1.44772 25 2H27C27 0.343146 25.6569 -1 24 -1V1ZM2 -1C0.343146 -1 -1 0.343145 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z"
            fill="#C8CBCC"
        />
    </svg>
);

const nextIcon = (
    <svg
        style={{ cursor: "pointer" }}
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.5 11.6273C16.1667 12.0152 16.1667 12.9848 15.5 13.3727L9.5 16.8635C8.83333 17.2514 8 16.7665 8 15.9908L8 9.00921C8 8.23348 8.83333 7.74864 9.5 8.13651L15.5 11.6273Z"
            fill="#37474F"
        />
        <path
            d="M2 1H24V-1H2V1ZM25 2V23H27V2H25ZM24 24H2V26H24V24ZM1 23V2H-1V23H1ZM2 24C1.44772 24 1 23.5523 1 23H-1C-1 24.6569 0.343146 26 2 26V24ZM25 23C25 23.5523 24.5523 24 24 24V26C25.6569 26 27 24.6569 27 23H25ZM24 1C24.5523 1 25 1.44772 25 2H27C27 0.343146 25.6569 -1 24 -1V1ZM2 -1C0.343146 -1 -1 0.343145 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z"
            fill="#C8CBCC"
        />
    </svg>
);

const ExternalOrders = (props) => {
    let initialStatusTabs = {
        all: true,
        active: false,
        completed: false,
        deleted: false,
    };

    const isMobile = useMediaQuery({ maxWidth: 480 });
    const isMobileOrTablet = useMediaQuery({ maxWidth: 1024 });

    const [popupModal, setShowPopupModal] = useState(false);
    const [user] = useContext(UserContext);
    const setShowLoading = useContext(LoadingContext)[1];

    const perPage = 8;
    const [orders, setOrders] = useState([]);
    const [page, setPage] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [search, setSearch] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    const [filterButtons, setFilterButtons] = useState(initialStatusTabs);
    const [actualOrder, setActualOrder] = useState();

    const handlePageClick = (evt) => {
        const selectedPage = evt.selected;
        const offset = selectedPage * perPage;
        setPage(filteredOrders.slice(offset, offset + perPage));
    };

    const getExternalOrders = () => {
        setShowLoading(true);
        axios({
            method: "POST",
            url: "https://kakaomarket.cr/wp-json/sellerconsole/v1/get_external_orders",
            data: {
                vendorId: user.vendorId,
            },
        })
            .then((response) => {
                let data = JSON.parse(response.data).result;
                if (response.status === 200) {
                    setOrders(data);
                    setPage(data.slice(0, perPage));
                    setFilteredOrders(data);
                }
            })
            .finally(() => {
                setShowLoading(false);
            });
    };

    useEffect(() => {
        getExternalOrders();
    }, []);

    const handleOnSearch = ({ target: { value } }) => {
        setSearch(value);
        setDateFilter("");

        const searchedOrders = orders.filter(({ id, details, customerName, vendorName }) => {
            const orderSearched = id
                .toLowerCase()
                .trim()
                .includes(value.toLocaleLowerCase().trim());
            const detailSearched = details
                .toLowerCase()
                .trim()
                .includes(value.toLocaleLowerCase().trim());
            const clientSearched = customerName
                .toLowerCase()
                .trim()
                .includes(value.toLocaleLowerCase().trim());
            const vendorSearched = vendorName
                .toLowerCase()
                .trim()
                .includes(value.toLocaleLowerCase().trim());
            return orderSearched || detailSearched || clientSearched || vendorSearched;
        });
        setFilteredOrders(searchedOrders);
        setPage(searchedOrders.slice(0, perPage));
    };

    const handleOnDateFilterChange = ({ target: { value } }) => {
        const filteredOrders = orders.filter(({ date }) => {
            const newDate = date.split("T")[0];
            return newDate === value;
        });
        setDateFilter(value);
        setFilteredOrders(filteredOrders);
        setPage(filteredOrders.slice(0, perPage));

        setSearch("");
    };

    const handleOnTableType = (value) => {
        let data;
        let data1;
        switch (value) {
            case "all":
                setPage(orders.slice(0, perPage));
                setFilteredOrders(orders);
                setFilterButtons({
                    all: true,
                    active: false,
                    completed: false,
                    deleted: false,
                });
                break;
            case "active":
                data1 = orders.filter(
                    ({ paymentState }) =>
                        paymentState.toString() !== "failed" &&
                        paymentState.toString() !== "fail" &&
                        paymentState.toString() !== "" &&
                        paymentState.toString() !== "reject"
                );
                data = data1.filter(
                    ({ status }) =>
                        status !== "completed" &&
                        status !== "trash" &&
                        status !== "failed" &&
                        status !== "cancelled"
                );
                setPage(data.slice(0, perPage));
                setFilteredOrders(data);
                setFilterButtons({
                    all: false,
                    active: true,
                    completed: false,
                    deleted: false,
                });
                break;
            case "completed":
                data1 = orders.filter(({ paymentState }) => paymentState === "aproved");
                data = data1.filter(({ status }) => status === "completed");
                setPage(data.slice(0, perPage));
                setFilteredOrders(data);
                setFilterButtons({
                    all: false,
                    active: false,
                    completed: true,
                    deleted: false,
                });
                break;
            case "deleted":
                data1 = orders.filter(
                    ({ paymentState }) =>
                        paymentState.toString() === "failed" ||
                        paymentState.toString() === "fail" ||
                        paymentState.toString() === "" ||
                        paymentState.toString() === "rejected"
                );
                data = orders.filter(
                    ({ status }) => status === "trash" || status === "cancelled"
                );
                setPage(data.slice(0, perPage));
                setFilteredOrders(data);
                setFilterButtons({
                    all: false,
                    active: false,
                    completed: false,
                    deleted: true,
                });
                break;
            default:
                break;
        }
    };

    const showStatus = (status, paymentState) => {
        if (paymentState === "pending") {
            if (status !== "trash") {
                return <CircleStatus color="#FFFF00" name="PENDIENTE" />;
            } else if (status === "trash") {
                return <CircleStatus color="#FF5A5F" name="ELIMINADA" />;
            }
        } else if (
            paymentState === "aproved" ||
            paymentState === "approved" ||
            paymentState === "fail"
        ) {
            if (status === "completed") {
                return <CircleStatus color="#27A36E" name="COMPLETADA" />;
            } else if (status === "cancelled") {
                return <CircleStatus color="#FF5A5F" name="CANCELADA" />;
            } else if (status === "processing") {
                return <CircleStatus color="#00B8D4" name="PROCESANDO" />;
            } else if (status === "trash") {
                return <CircleStatus color="#FF5A5F" name="ELIMINADA" />;
            } else if (status === "on-hold") {
                return <CircleStatus color="#6C7980" name="EN ESPERA" />;
            } else if (status === "failed") {
                return <CircleStatus color="#FF6D00" name="FALLO" />;
            } else if (status === "refunded") {
                return <CircleStatus color="#7D3C98" name="DEVUELTO" />;
            } else {
                return <CircleStatus color="#FFFF00" name="PENDIENTE" />;
            }
        } else if (paymentState === "failed" || paymentState === "fail") {
            return <CircleStatus color="#FF6D00" name="FALLO" />;
        } else if (paymentState === "reject") {
            return <CircleStatus color="#FF5A5F" name="RECHAZADO" />;
        } else if (status === "trash") {
            return <CircleStatus color="#FF5A5F" name="ELIMINADA" />;
        }
        return <CircleStatus color="#FFFF00" name="PENDIENTE" />;
    };

    const handleActiveModalOrder = (order) => {
        setActualOrder(order);
        setShowPopupModal(true);
    };

    return (
        <div className="main-container">
            <h1 className="title-orders">ÓRDENES EXTERNAS</h1>
            <div className="headerOptions">
                <div className="scrollOptions">
                    <ul>
                        <li
                            className={`${filterButtons.all ? "isActive" : ""}`}
                            onClick={() => handleOnTableType("all")}
                        >
                            <p>TODAS</p>
                        </li>
                        <li
                            className={`${filterButtons.active ? "isActive" : ""}`}
                            onClick={() => handleOnTableType("active")}
                        >
                            <p>ACTIVAS</p>
                        </li>
                        <li
                            className={`${filterButtons.completed ? "isActive" : ""}`}
                            onClick={() => handleOnTableType("completed")}
                        >
                            <p>COMPLETADAS</p>
                        </li>
                        <li
                            className={`${filterButtons.deleted ? "isActive" : ""}`}
                            onClick={() => handleOnTableType("deleted")}
                        >
                            <p>
                                <FontAwesomeIcon
                                    style={{ width: "10%", marginRight: "2.5%" }}
                                    icon={faTrashAlt}
                                />
                                ELIMINADAS
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="search-container">
                <label className="column-text" style={{ display: "flex" }}>
                    <svg
                        style={{ position: "absolute", padding: 12 }}
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6.143 10.7144C8.66775 10.7144 10.7145 8.66764 10.7145 6.14289C10.7145 3.61814 8.66775 1.57143 6.143 1.57143C3.61825 1.57143 1.57153 3.61814 1.57153 6.14289C1.57153 8.66764 3.61825 10.7144 6.143 10.7144Z"
                            stroke="#6C7980"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M11.8568 11.8571L9.37109 9.37138"
                            stroke="#6C7980"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        onChange={handleOnSearch}
                        value={search}
                        className="custom-input"
                        style={{ padding: "4px 25px", width: "100%", height: "30px" }}
                        type="text"
                        placeholder="Buscar"
                    />
                </label>

                <label className="column-text">
                    <span>FECHA</span>
                    <input
                        onChange={handleOnDateFilterChange}
                        value={dateFilter}
                        className="custom-input"
                        type="date"
                    />
                </label>
            </div>
            {!isMobile && (
                <div className="table-container">
                    <div className="table-column">
                        <div className="column-name" style={{ flexBasis: "7%" }}>
                            <h3>ORDEN</h3>
                        </div>
                        <div className="column-name">
                            <h3>DETALLE</h3>
                        </div>
                        <div className="column-name">
                            <h3>TIPO</h3>
                        </div>
                        <div className="column-name">
                            <h3>CLIENTE</h3>
                        </div>
                        <div className="column-name">
                            <h3>VENDEDOR</h3>
                        </div>
                        <div className="column-name" style={{ flexBasis: "7%" }}>
                            <h3>FECHA</h3>
                        </div>
                        <div className="column-name" style={{ flexBasis: "2%" }}>
                            <h3>ESTADO</h3>
                        </div>
                        <div className="column-name" style={{ flexBasis: "2%" }}>
                            <h3>TOTAL (₡)</h3>
                        </div>
                    </div>
                    <div className="table-rows">
                        {filteredOrders.length !== 0 &&
                            page.map((order) => {
                                let dateHoursString = order.dateHours.date.substr(0, 19);
                                return (
                                    <div className="table-row" key={order.id}>
                                        <div
                                            className="row-data"
                                            style={{ flexBasis: "7%" }}
                                            onClick={() => {
                                                handleActiveModalOrder(order);
                                            }}
                                        >{`#${order.id}`}</div>
                                        <div
                                            className="row-data"
                                            onClick={() => {
                                                handleActiveModalOrder(order);
                                            }}
                                        >
                                            {order.details}
                                        </div>
                                        <div
                                            className="row-data"
                                            onClick={() => {
                                                handleActiveModalOrder(order);
                                            }}
                                        >
                                            {order.vendorName === "Kakao Internacional" ? "Kakao Internacional" : parseFloat(order.bpPoints) < 0 ? "Puntos Banco Popular" : "Kakao Market"}
                                        </div>
                                        <div
                                            className="row-data"
                                            onClick={() => {
                                                handleActiveModalOrder(order);
                                            }}
                                        >
                                            {order.customerName}
                                        </div>
                                        <div
                                            className="row-data"
                                            onClick={() => {
                                                handleActiveModalOrder(order);
                                            }}
                                        >
                                            {order.vendorName}
                                        </div>
                                        <div
                                            className="row-data"
                                            style={{ flexBasis: "7%" }}
                                            onClick={() => {
                                                handleActiveModalOrder(order);
                                            }}
                                        >
                                            {dateHoursString}
                                        </div>
                                        <div className="row-data" style={{ flexBasis: "2%" }}>
                                            {showStatus(
                                                order.status,
                                                order.paymentState[0]
                                            )}
                                        </div>
                                        <div
                                            className="row-data"
                                            style={{ flexBasis: "2%" }}
                                            onClick={() => {
                                                handleActiveModalOrder(order);
                                            }}
                                        >
                                            {order.total}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            )}

            {isMobile && (
                <div className="containerMobileOrders">
                    {filteredOrders.length !== 0 &&
                        page.map((order) => {
                            let dateHoursString = order.dateHours.date.substr(0, 19);
                            return (
                                <div className="cardMobileOrders" key={order.id}>
                                    <div className="itemContainerOrders">
                                        <div
                                            className="order-info"
                                            onClick={() => {
                                                handleActiveModalOrder(order);
                                            }}
                                        >
                                            <p style={{ textDecoration: "underline" }}>
                                                <span>Order</span> #{order.id}
                                            </p>
                                        </div>
                                        <div className="order-actions">
                                            {showStatus(
                                                order.status,
                                                order.paymentState[0]
                                            )}
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="itemContainerOrders">
                                        <div className="order-info">
                                            <p>
                                                <span>Detalle</span>
                                            </p>
                                        </div>
                                        <div className="order-data">
                                            <p>{order.details}</p>
                                        </div>
                                    </div>
                                    <div className="itemContainerOrders">
                                        <div className="order-info">
                                            <p>
                                                <span>TIPO</span>
                                            </p>
                                        </div>
                                        <div className="order-data">
                                            <p>{order.vendorName === "Kakao Internacional" ? "Kakao Internacional" : parseFloat(order.bpPoints) < 0 ? "Puntos Banco Popular" : "Kakao Market"}</p>
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="itemContainerOrders">
                                        <div className="order-info">
                                            <p>
                                                <span>Cliente</span>
                                            </p>
                                        </div>
                                        <div className="order-data">
                                            <p> {order.customerName}</p>
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="itemContainerOrders">
                                        <div className="order-info">
                                            <p>
                                                <span>Vendedor</span>
                                            </p>
                                        </div>
                                        <div className="order-data">
                                            <p>{order.vendorName}</p>
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="itemContainerOrders">
                                        <div className="order-info">
                                            <p>
                                                <span>Fecha</span>
                                            </p>
                                        </div>
                                        <div className="order-data">
                                            <p>{dateHoursString}</p>
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="itemContainerOrders">
                                        <div className="order-info">
                                            <p>
                                                <span>Precio</span>
                                            </p>
                                        </div>
                                        <div className="order-data">
                                            <p> {order.total}</p>
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                </div>
                            );
                        })}
                </div>
            )}
            {filteredOrders.length === 0 && (
                <div className="table-row" style={{ justifyContent: "center" }}>
                    No hay órdenes externas
                </div>
            )}
            <div>
                <ReactPaginate
                    onPageChange={handlePageClick}
                    previousLabel={prevIcon}
                    nextLabel={nextIcon}
                    breakLabel={"..."}
                    pageCount={Math.ceil(filteredOrders.length / perPage)}
                    pageRangeDisplayed={isMobile ? 2 : 5}
                    marginPagesDisplayed={isMobile ? 1 : 2}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                />
            </div>

            <ModalContainer
                width={isMobileOrTablet ? "80%" : "60%"}
                style={{ alignItems: "center" }}
                handleClose={() => {
                    setShowPopupModal(false);
                }}
                active={popupModal}
            >
                <ModalBody>
                    <OrderViewModal
                        handleClose={() => {
                            setShowPopupModal(false);
                        }}
                        order={actualOrder}
                    />
                </ModalBody>
            </ModalContainer>
        </div>
    );
};

const CircleStatus = ({ color, name }) => {
    return (
        <div>
            <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="4" cy="4" r="4" fill={color} />
            </svg>
            <span className="statusOrders">{name}</span>
        </div>
    );
};

export default ExternalOrders;